var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('magic-topbar'),_vm._v(" "),_c('magic-sidebar',{attrs:{"type":_vm.leftSidebarType,"width":_vm.layoutWidth}}),_vm._v(" "),_c('div',{staticClass:"main-content",style:([
      _vm.$route.name == 'profile'
        ? { 'margin-left': '0' }
        : _vm.$route.name.includes('chats')
        ? {}
        : {} ])},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('Nuxt')],1)]),_vm._v(" "),_c('Footer')],1),_vm._v(" "),_c('RightSidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }